/**
 * @generated SignedSource<<4732af6858b08b1fe4bb0a8b7d328690>>
 * @relayHash 4b18b4ff9601de19f4d0077ada639876
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d1924a0735559f1834fc00243213aa6efd6aadfed5f006ffbf847070cf61ae0c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraUpdateTimeTrackingFieldInput = {
  id: string;
  originalEstimate?: JiraEstimateInput | null | undefined;
  remainingEstimate?: JiraEstimateInput | null | undefined;
};
export type JiraEstimateInput = {
  timeInSeconds: AGG$Long;
};
export type originalEstimate_issueFieldOriginalEstimate_OriginalEstimateField_Mutation$variables = {
  input: JiraUpdateTimeTrackingFieldInput;
};
export type originalEstimate_issueFieldOriginalEstimate_OriginalEstimateField_Mutation$data = {
  readonly jira: {
    readonly updateTimeTrackingField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly originalEstimate: {
          readonly timeInSeconds: AGG$Long | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type originalEstimate_issueFieldOriginalEstimate_OriginalEstimateField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateTimeTrackingField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly originalEstimate: {
          readonly timeInSeconds: AGG$Long | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type originalEstimate_issueFieldOriginalEstimate_OriginalEstimateField_Mutation = {
  rawResponse: originalEstimate_issueFieldOriginalEstimate_OriginalEstimateField_Mutation$rawResponse;
  response: originalEstimate_issueFieldOriginalEstimate_OriginalEstimateField_Mutation$data;
  variables: originalEstimate_issueFieldOriginalEstimate_OriginalEstimateField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraTimeTrackingFieldPayload",
        "kind": "LinkedField",
        "name": "updateTimeTrackingField",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          },
          {
            "concreteType": "JiraTimeTrackingField",
            "kind": "LinkedField",
            "name": "field",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "concreteType": "JiraEstimate",
                "kind": "LinkedField",
                "name": "originalEstimate",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimate_OriginalEstimateField_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "originalEstimate_issueFieldOriginalEstimate_OriginalEstimateField_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d1924a0735559f1834fc00243213aa6efd6aadfed5f006ffbf847070cf61ae0c",
    "metadata": {},
    "name": "originalEstimate_issueFieldOriginalEstimate_OriginalEstimateField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5898bdc1ce7c6e5406fecfc4b0d46970";

export default node;
